var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink45Deg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-45deg",
    transform: "translate(-7.393 -5.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(7.393 5.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M11.459,18.382,8.98,20.861a5.42,5.42,0,0,0,7.665,7.665l3.3-3.3a5.42,5.42,0,0,0-1.5-8.722l-1.059,1.059a1.81,1.81,0,0,0-.278.36,3.613,3.613,0,0,1,1.555,6.029l-3.3,3.3a3.615,3.615,0,0,1-5.112-5.113l1.433-1.431a7.26,7.26,0,0,1-.231-2.325Z",
    transform: "translate(-7.393 -10.114)",
    fill: "#00c8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.709,10.786a5.42,5.42,0,0,0,1.5,8.722l1.4-1.4a3.613,3.613,0,0,1-1.619-6.045l3.3-3.3A3.615,3.615,0,0,1,28.4,13.871L26.967,15.3a7.269,7.269,0,0,1,.231,2.325l2.478-2.479a5.42,5.42,0,1,0-7.665-7.665Z",
    transform: "translate(-11.264 -5.896)",
    fill: "#00c8ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink45Deg);
export default __webpack_public_path__ + "static/media/link-45deg.1045df8baf57023bbbd57218cc235b6a.svg";
export { ForwardRef as ReactComponent };